import { DTO__base } from '@shared/common/DTO__base';
import { DTO__number_range } from '@shared/dto/generation/settings/DTO__number_range';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';

export class DTO__color extends DTO__base {
  /*
   * STATIC FIELDS
   */

  static _class_name_static: string = ENUM__dto_class_name.COLOR;

  /*
   * STATIC FIELDS
   */
  static readonly COLOR_MASK_ACTIVE = new DTO__color().clone({ r: 255, g: 255, b: 255 });
  static readonly COLOR_MASK_NON_ACTIVE = new DTO__color().clone({ r: 0, g: 0, b: 0 });

  static readonly COLOR_LINE_GUIDANCE_NON_ACTIVE = new DTO__color().clone({ r: 0, g: 0, b: 0 });
  static readonly COLOR_LINE_GUIDANCE_ACTIVE = new DTO__color().clone({ r: 255, g: 255, b: 255 });

  static readonly COLOR_WHITE = new DTO__color().clone({ r: 255, g: 255, b: 255 });
  static readonly COLOR_GRAY = new DTO__color().clone({ r: 128, g: 128, b: 128 });
  /*
   * STATIC METHODS
   */

  static create(r: number, g: number, b: number): DTO__color {
    let out = new DTO__color();

    [out.r, out.g, out.b] = [r, g, b];

    return out;
  }

  /*
   * FIELDS
   */

  r!: number;
  g!: number;
  b!: number;

  /*
   * METHODS
   */

  apply_rgb(data: Uint8ClampedArray | Buffer<ArrayBufferLike>, offset: number) {
    data[offset] = this.r; // R
    data[offset + 1] = this.g; // G
    data[offset + 2] = this.b; // B
  }

  apply_rgba(data: Uint8ClampedArray | Buffer<ArrayBufferLike>, offset: number, alpha: number = 255) {
    this.apply_rgb(data, offset);

    data[offset + 3] = alpha; // Alpha
  }

  to_object() {
    return { r: this.r, g: this.g, b: this.b };
  }

  assert_standard_fields(): void {
    let range = new DTO__number_range(0, 255);

    range.assert_number_in_range(this.r);
    range.assert_number_in_range(this.g);
    range.assert_number_in_range(this.b);
  }
}
